import React, { useEffect, useReducer } from "react";
import * as notify from "../../../../shared/notify";

import Panel from "../nutritionpanel/components/panel";
import PanelReadOnly from "../nutritionpanel/components/panel-read-only";
import PanelTabs from "../panel-tab";

import { reducer, initialState } from "../nutritionpanel/reducers";
import { sendSingleAttributeData } from "../../lib/attribute-data";
import { supplementTemplate } from "../nutritionpanel/lib/templates";
import { nutrientValidation } from "../nutritionpanel/lib/helpers";
import { useKeyboardShortcut } from "../../../../shared/hooks/hotkeys";

import "../nutritionpanel/nutrition.scss";

const SupplementIndex = (props) => {
    const readOnly = false;
    const [state, dispatch] = useReducer(reducer, initialState);
    const hotkeys = useKeyboardShortcut();

    useEffect(() => {
        async function fetchData() {
            if (!props.value.panels) {
                addPanel();
            } else {
                dispatch({ type: "SAVE_PANELS", panels: props.value.panels || [], isDirty: false });
            }
        }

        fetchData();
    }, []);

    useEffect(() => {
        switch (hotkeys) {
            case "SAVE":
                savePanel();
                break;
            default:
                break;
        }
    }, [hotkeys]);

    const changeTab = (tabIndex) => {
        dispatch({ type: "SET_PANEL_INDEX", selectedPanel: tabIndex });
    };

    const addPanel = () => {
        const template = supplementTemplate();
        dispatch({ type: "ADD_PANEL", template: template });
    };

    const removePanel = () => {
        dispatch({ type: "REMOVE_PANEL" });
    };

    const updateField = (key, value, column = false) => {
        dispatch({ type: "UPDATE_STATE", key: key, value: value, column: column });
    };

    const updateFieldDeep = (section, key, value, column = false) => {
        dispatch({ type: "UPDATE_DEEP_STATE", section: section, key: key, value: value, column: column });
    };
    const addFact = (section) => {
        dispatch({ type: "ADD_FACT", section: section });
    };

    const updateFacts = (key, value, column = false, skipReorder) => {
        dispatch({ type: "UPDATE_FACTS", key: key, value: value, column: column, skipReorder });
    };

    const addColumn = () => {
        dispatch({ type: "CLONE_COLUMN" });
    };
    const removeColumn = (columnIndex) => {
        dispatch({ type: "REMOVE_COLUMN", columnIndex });
    };

    const validatePanel = () => {
        let validNutrients = true;
        state.panels.forEach((panel) => {
            if (!nutrientValidation(panel.columns[0].dietary.facts) || !nutrientValidation(panel.columns[0].vitamineral.facts)) {
                validNutrients = false;
                notify.error("Nutrient can not be blank");
            }
        });

        return validNutrients;
    };

    const savePanel = async () => {
        // Validation
        if (!validatePanel()) {
            return false;
        }

        try {
            if (!props.skipInternalSave) {
                const response = await sendSingleAttributeData(props.codingWipKey, props.taskId, props.sourcePage, {
                    definition: props.attribute.uuid,
                    type: props.attribute.componentType,
                    value: { panels: state.panels },
                });

                if (!response) {
                    return false;
                }

                notify.success("Saved");
            }

            props.updateOnChange(props.attribute.uuid, { panels: state.panels }, props.attribute.componentType);
            dispatch({ type: "SET_DIRTY_FLAG", isDirty: false });

            return true;
        } catch (err) {
            notify.error(err);

            return false;
        }
    };

    const closePanel = async () => {
        if (state.isDirty) {
            const confirm = await notify.confirm("You have unsaved data.  Are you sure you want to navigate away? Unsaved data will be lost!");

            if (!confirm) {
                return;
            }
        }

        props.closeModal();
    };

    const panel =
        state.panels.length > 0 ? (
            !readOnly ? (
                <Panel
                    key={`panel_${state.selectedPanel}`}
                    panel={state.panels[state.selectedPanel]}
                    selectedIndex={state.selectedPanel}
                    addFact={addFact}
                    updateFacts={updateFacts}
                    updateField={updateField}
                    updateFieldDeep={updateFieldDeep}
                    addPanel={addPanel}
                    removePanel={removePanel}
                    addColumn={addColumn}
                    removeColumn={removeColumn}
                    showDescription={true}
                />
            ) : (
                <PanelReadOnly
                    key={`panel_${state.selectedPanel}`}
                    panel={state.panels[state.selectedPanel]}
                    selectedIndex={state.selectedPanel}
                    showDescription={true}
                />
            )
        ) : null;

    return (
        <div className="container">
            <div className="button-group">
                <button className="button" onClick={closePanel}>
                    Back
                </button>
                <h1 className="txt-center">Supplement Panel</h1>
                {!readOnly && (
                    <button className="button -primary" onClick={savePanel}>
                        Save
                    </button>
                )}
            </div>
            <PanelTabs tabs={state.panels} addTab={addPanel} changeTab={changeTab} selectedIndex={state.selectedPanel} readOnly={readOnly} />

            {panel}
        </div>
    );
};

export default SupplementIndex;
